import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class PurchaseRequisitionService extends Service {
    constructor() {
        super();
        this.baseURL = 'inventory/PurchaseRequisition';
    }

    async findAllOpen() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + '/all/status/OPEN', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            }
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }

    async findProductByBarcode(barcode) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + '/product/barcode/' + encodeURIComponent(barcode), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            }
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }

    async findProductByBoxBarcode(boxBarcode) {
        return GeneralUtils.fetchWithAuth(
            SERVER_URL + this.baseURL + '/product/boxBarcode/' + encodeURIComponent(boxBarcode),
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
                }
            }
        )
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }

    async getCostWarnings(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + '/' + id + '/cost-warnings', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            }
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }

    async updateItem(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/items", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async checkout(id, data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/" + id + "/checkout", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async approve(id, data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/" + id + "/approve", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: data ? JSON.stringify(data) : undefined
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async createReturnFromWaste(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/" + id + "/create-return-from-waste", {
            crossDomain: true,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async sendSupplierEmail(id, data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/" + id + "/send-supplier-email", {
            crossDomain: true,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify(data)
        }).then(async response => {
            const result = response.clone();
            GeneralUtils.notification(response, true);
            const body = await GeneralUtils.responseToJson(result);
            return {
                ...body,
                ok: response.ok,
                httpStatus: response.status
            };
        }).catch(error => {
            GeneralUtils.notification(error);
            return {ok: false};
        });
    }

    async assignPurchaseOrder(id, assignedPurchaseRequisitionId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/" + id + "/assign-purchase-order", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify({assignedPurchaseRequisitionId})
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async assignDeliveryNote(id, assignedPurchaseRequisitionId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/" + id + "/assign-delivery-note", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify({assignedPurchaseRequisitionId})
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}
